//@ts-ignore
import { parseFetchResponse } from '@mindtickle/api-helpers/helpers';

export const SIDEBAR_URL = '/sidebar';

export async function getNavigationDataResponse() {
  let apiPromiseResponse =
    (await window.SIDEBAR_API_PROMISE_MAP?.[SIDEBAR_URL]) ??
    (await fetch(SIDEBAR_URL, { credentials: 'include' }));

  if (window.SIDEBAR_API_PROMISE_MAP?.[SIDEBAR_URL]) {
    window.SIDEBAR_API_PROMISE_MAP[SIDEBAR_URL] = null;
  }

  return parseFetchResponse(apiPromiseResponse, SIDEBAR_URL);
}
